import { render, staticRenderFns } from "./SelectAddressModal.vue?vue&type=template&id=35e7e8dc&scoped=true"
import script from "./SelectAddressModal.vue?vue&type=script&lang=ts"
export * from "./SelectAddressModal.vue?vue&type=script&lang=ts"
import style0 from "./SelectAddressModal.vue?vue&type=style&index=0&id=35e7e8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e7e8dc",
  null
  
)

export default component.exports